var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgCallbacksupport(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 13,
    height: 13,
    viewBox: "0 0 13 13",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M3.55444 5.44278L7.52911 9.39056C7.95506 8.89739 10.6519 6.00622 12 9.95522C12 9.95522 11.8582 12 8.94811 12C6.8905 12 4.76139 9.53233 3.27089 8.12189C1.99367 6.92289 1 5.37189 1 3.96144C1 1.07089 2.98733 1 2.98733 1C7.52911 2.551 3.55506 5.44278 3.55506 5.44278H3.55444Z",
    stroke: "black",
    strokeMiterlimit: 10,
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCallbacksupport);
export default __webpack_public_path__ + "static/media/callbacksupport.8a1a5bef2489963186453dc10a025bd7.svg";
export { ForwardRef as ReactComponent };